/**
 * Mirrors `config/service_order.php` → `subcategories` (display names).
 * Used for local SEO sub-paths and internal links. Keep in sync with backend config.
 */
export const SERVICE_ORDER_SUBCATEGORIES: Readonly<Record<string, readonly string[]>> = {
    'Cleaning Services': [
        'Home Cleaning',
        'Deep Cleaning',
        'Move In / Move Out Cleaning',
        'Post-Construction Cleaning',
        'Disinfecting Services',
        'Office Cleaning',
        'Carpet Cleaning',
        'Blinds Cleaning',
        'Window Washing',
        'Building Pressure Washing',
        'Yard Cleaning',
    ],
    'Home Improvement & Renovation': [
        'Renovation',
        'Kitchen Remodel',
        'Bathroom Remodel',
        'Interior Design',
        'Painting',
        'Wallpapering Service',
        'Cabinets',
        'Carpentry Services',
        'Deck Building',
        'Deck Restoration Services',
        'Fence Installation & Repair Services',
        'Welding',
    ],
    'Handyman & Repairs': [
        'Building Repair',
        'Plumbing',
        'Electrical',
        'Appliance Repair',
        'Heating & Cooling',
        'HVAC Service and Installation',
        'Sealing & Caulking',
        'Light Installation',
        'Window & Blinds Repair',
        'Install Air Conditioner',
        'Install Blinds & Window Treatments',
        'Smart Home Installation',
        'Home Theater Installation',
    ],
    'Assembly & Installation': ['Furniture Assembly', 'TV Mounting', 'Home Appliances Installation'],
    'Tech & Electronics': [
        'Computers & Laptops',
        'Cellphones & Tablets',
        'TVs',
        'Server & Network',
        'Business Printing Services',
        'Printer Services',
    ],
    'Moving & Hauling': [
        'Moving Helpers',
        'Packing Services',
        'Unpacking Services',
        'Heavy Lifting',
        'Junk Pickup',
        'Rearranging Furniture',
        'Vehicle Transport',
        'Storage Solutions',
    ],
    'Shopping & Delivery': ['Delivery Service', 'Grocery Shopping & Delivery', 'Running Your Errands'],
    'Auto Services': [
        'Car Repair',
        'Oil Change',
        'Tire Service',
        'Car Detailing',
        'Car Washing',
        'Car Electronics',
        'Car Battery',
    ],
    'Health, Wellness & Care': [
        'Hair Services',
        'Nail Care',
        'Massage',
        'Skin Care',
        'Personal Training',
        'Child Care',
        'Senior Care',
        'Medical Care',
    ],
    'Pet Care': ['Pet Sitting', 'Dog Walking', 'Pet Grooming', 'Pet Training', 'Pet Boarding', 'Pet Transportation'],
    'Event Services': [
        'Event Planning',
        'Wedding Planning',
        'Event Setup & Decoration',
        'Event Cleaning',
        'Photography & Videography',
        'DJ & Entertainment',
        'Catering & Personal Chef',
    ],
    'Seasonal & Outdoor Maintenance': ['Snow Removal', 'Home Winter Maintenance', 'Landscaping', 'Gutter Cleaning'],
    'Home Safety & Security': [
        'Home Security System Installation',
        'Security Camera Installation',
        'Smart Locks Installation',
        'Alarm System Setup',
    ],
    'Office & Workspace': [
        'Office Furniture Assembly',
        'Office Setup & Organization',
        'Office Tech Setup',
        'Workspace IT Support',
    ],
    'Legal & Financial Services': [
        'Tax Preparation',
        'Bookkeeping',
        'Accounting',
        'Business Registration Help',
        'Contract Review',
        'Notary Services',
    ],
    'Education & Lessons': [
        'Academic Tutoring',
        'Language Lessons',
        'Music Lessons',
        'Exam Preparation',
        'Computer & Software Training',
        'Professional Skills Coaching',
    ],
    'Property & Environmental Services': [
        'Pest Control',
        'Wildlife Removal',
        'Mold Inspection',
        'Asbestos Testing',
        'Insulation & Weatherproofing',
    ],
    'Pool & Spa Services': ['Pool Cleaning', 'Hot Tub Maintenance', 'Pool Repair', 'Water System Maintenance'],
    'Exterior & Structural': ['Roof Repair', 'Siding Installation', 'Concrete & Masonry', 'Foundation Repair'],
    'Clothing Alteration & Tailoring': ['Tailoring & Alterations', 'Repairs & Mending', 'Formal Wear Adjustments'],
} as const;
